'use client';
import * as React from 'react';
import type { ReactNode } from 'react';
import * as Icons from './icons';

interface JukeboxHeaderBarProps {
  title: string;
  rightContent?: ReactNode;
  middleContent?: ReactNode;
  showNav?: boolean;
}

export function JukeboxHeaderBar({
  title,
  rightContent,
  middleContent,
  showNav,
}: JukeboxHeaderBarProps): React.JSX.Element {
  return (
    <div>
      <div className="flex flex-col">
        <header className="shadow-layout-header sticky top-0 z-50 h-16 bg-white">
          <div className="flex h-full items-center justify-between px-6">
            <div className="flex items-center">
              <a className="flex items-center" href="/">
                <Icons.Icons.JukeboxLogo height={20} width={202} />
              </a>
            </div>
            <div className="mx-auto">
              <h3 className="text-lg font-medium">{title}</h3>
            </div>

            {rightContent ? rightContent : null}
          </div>
        </header>
        {middleContent ? (
          <div className="flex flex-1">
            <main className={`flex-1 ${showNav === true ? 'ml-64' : ''}`}>
              <div className="sticky top-16 z-40 bg-white shadow-sm hidden sm:block">
                <div className="container py-4 md:mx-auto">{middleContent}</div>
              </div>
            </main>
          </div>
        ) : null}
      </div>
    </div>
  );
}
